import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { uploadFile } from 'pages/Upload/utils';
import { addUserDocuments } from 'modules/userDocuments/api';
import { getPatientCondition, getUserConditionProfile, getUserProfileId } from 'modules/user/utils';
import { getOnJobStatusChange } from 'pages/Upload/uploadHelpers';
import { UploadFlow } from './UploadFlow';

// is intended for (not) authenticated main user (not hcp patient)
export const UploadPopup = ({
  onSuccess,
  onUpdate,
  onBeforeIntake,
  condition,
  onGotoResultsAction,
  presentNgsNotFound = false,
}) => {
  const dispatch = useDispatch();
  const {
    profile: { data: profile },
  } = useSelector((state) => ({
    profile: state.profile,
  }), shallowEqual);

  const profileId = getUserProfileId(profile);
  const onJobStatusChange = getOnJobStatusChange({ dispatch, keepQstack: true });

  const handleUpload = ({
    files,
    getRecaptchaTokenAsync,
    onUpload,
    onError,
  }) => {
    uploadFile({
      files,
      getRecaptchaTokenAsync,
      onUpload,
      onError,
      onJobStatusChange,
      condition: getPatientCondition(getUserConditionProfile(profile), condition),
    });
  };

  const handleUploadedFiles = async (files, { jobId }) => {
    if (!profileId) {
      return;
    }
    try {
      await addUserDocuments({
        jobId,
        files,
        source: 'upload',
        profileId,
      });
    } catch (ex) {
      console.error('addUserDocuments ex', ex);
    }
  };

  return (
    <UploadFlow
      condition={condition}
      onSuccess={onSuccess}
      onUpdate={onUpdate}
      onBeforeIntake={onBeforeIntake}
      onUploadFiles={handleUpload}
      onUploadedFilesChange={handleUploadedFiles}
      onGotoResultsAction={onGotoResultsAction}
      presentNgsNotFound={presentNgsNotFound}
    />
  );
};

UploadPopup.propTypes = {
  onSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  condition: PropTypes.string,
  onBeforeIntake: PropTypes.func,
  onGotoResultsAction: PropTypes.func,
  presentNgsNotFound: PropTypes.bool,
};
